import { RELEASE_NOTES } from "~/lib/release-log-entries"
import type { AppFeature } from "~/server/models/appfeature"

// The Release Log: its own public page, outside the docs and the Console app.
export const RELEASE_LOG_URL = "/release-log"

export type ReleaseBanner = {
  // The log's slug: names the bar for dismissal and is the log it opens.
  slug: string
  message: string
  linkText: string
  until: string
}

/**
 * The bar shown across Console: the newest log set to `announce: banner`
 * whose `until` date hasn't passed and whose audience, if it has one, is
 * among the account's enabled features. Nothing to edit here for a new
 * release; the setting lives on the log in release-log-entries.ts.
 */
export function getCurrentBanner(
  features: readonly AppFeature[],
  today = new Date(),
): ReleaseBanner | undefined {
  const day = today.toISOString().slice(0, 10)
  const note = RELEASE_NOTES.find(
    (n) =>
      n.announce?.level === "banner" &&
      n.announce.until >= day &&
      (!n.announce.audience || features.includes(n.announce.audience)),
  )
  return note?.announce
    ? {
        slug: note.slug,
        message: note.announce.message,
        linkText: note.announce.linkText ?? "See what changed",
        until: note.announce.until,
      }
    : undefined
}
